import { QueryConfig } from "store/utils/query-config";

export const notificationsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"]
  }
};
